export const USER_SETTINGS_SUCCESS = 'USER_SETTINGS_SUCCESS';
